import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfNoRangesAccess: NavigationGuard = async () => {
  const authStore = useAuthStore();

  if (authStore.appAccess.nav.ranges) {
    return true;
  } else {
    return { name: 'home' };
  }
};
